import { queryOptions } from "@tanstack/react-query";
import { apiClient } from "~/lib/client";
import { handleApiError, handleResponse } from "~/utils/response";
import { appointmentKeys } from "./keys";
import { CreateRescheduleAppointmentResponseData, GetAvailableTimeSlotsResponseData, GetCalenderSettingsResponseData } from "../types";
import { buildQueryString } from "@workspace/lib/url";

export const useAvailableTimeSlotsQueryOptions = (ops: {
    date: string,
    timeZone: string
}) => {
    return queryOptions({
        queryKey: appointmentKeys.availableTimeSlots(ops.date, ops.timeZone),
        retry: false,
        queryFn: async () => {
            try {
                const response = await apiClient(`/appointments/available-slots${buildQueryString({ date: ops.date, time_zone: ops.timeZone })}`);

                const result = await handleResponse<GetAvailableTimeSlotsResponseData>(response);
                if (!result.success) {
                    throw new Error(result.error);
                  }
                  return result.data;
            } catch (error) {
                handleApiError(error);
            }
        },
    });
};

export const useCalenderSettingsQueryOptions = () => {
    return queryOptions({
        queryKey: appointmentKeys.calenderSettings(),
        retry: false,
        queryFn: async () => {
            try {
                const response = await apiClient(`/admin/schedules`);

                const result = await handleResponse<GetCalenderSettingsResponseData>(response);
                if (!result.success) {
                    throw new Error(result.error);
                  }
                  return result.data;
            } catch (error) {
                handleApiError(error);
            }
        },
    });
};

export const getCurrentAppointmentQueryOptions = (id?: string) => {
    return queryOptions({
        queryKey: appointmentKeys.appointmentById(id),
        retry: false,
        queryFn: async () => {
            try {
                const response = await apiClient(`/appointments/${id}`);

                const result = await handleResponse<CreateRescheduleAppointmentResponseData>(response);
                if (!result.success) {
                    throw new Error(result.error);
                  }
                  return result.data;
            } catch (error) {
                handleApiError(error);
            }
        },
        enabled: !!id
    });
};